import React from "react";
import { useTranslation } from "react-i18next";
import {
  NOTIFICATION_DATE_MODE,
  NOTIFICATION_SECTION,
  NOTIFICATION_SECTION_DATE_MODE,
  NOTIFICATION_SECTION_FALLBACK_LABEL,
  NOTIFICATION_SECTION_LABEL_KEY,
  NOTIFICATION_SECTION_SHOWS_COUNT,
} from "../constants";
import { formatBadgeCount } from "../model/notificationBadge";
import { NotificationCard } from "./NotificationCard";

export function NotificationSection({ section, count, onDismiss, onNavigate }) {
  const { t } = useTranslation();

  const label = t(NOTIFICATION_SECTION_LABEL_KEY[section.id], {
    defaultValue: NOTIFICATION_SECTION_FALLBACK_LABEL[section.id],
  });

  const isNew = section.id === NOTIFICATION_SECTION.NEW;

  const badgeValue = NOTIFICATION_SECTION_SHOWS_COUNT[section.id]
    ? formatBadgeCount(Number.isFinite(count) ? count : section.items.length)
    : null;

  const dateMode = NOTIFICATION_SECTION_DATE_MODE[section.id] ?? NOTIFICATION_DATE_MODE.RELATIVE;

  return (
    <section className="p-2 flex flex-col gap-2 w-full" aria-label={label}>
      <div className="flex items-center gap-2">
        <p className={`font-semibold text-sm ${isNew ? "text-secondaryColor" : "text-gray-500"}`}>
          {label}
        </p>
        {badgeValue && (
          <span className="bg-secondaryColor text-white text-[10px] font-medium px-1.5 py-0.5 rounded-full">
            {badgeValue}
          </span>
        )}
        <span className="flex-1 h-px bg-gray-200" />
      </div>

      {section.items.map((notification) => (
        <NotificationCard
          key={notification.id}
          notification={notification}
          dateMode={dateMode}
          onDismiss={onDismiss}
          onNavigate={onNavigate}
        />
      ))}
    </section>
  );
}
